import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { MagazineAnalyticsSetting_DesignPage_Query } from "./query";

type Props = {
	hotelID: string;
};

export const useMagazineAnalyticsQuery = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(MagazineAnalyticsSetting_DesignPage_Query, { variables: { hotelID } });

	return {
		data,
	};
};
